module.exports = __webpack_public_path__ + "static/scraper-8833d980be9e470bc5d413c76db9930d.png";